import dayjs from 'dayjs'
import React, { useState } from 'react'

import calendarioVerde from '../../../icones/iconesVersaoVerde/calendario.svg'

import 'dayjs/locale/pt-br'
import * as S from './styles'
import { GlobalStyles } from './styles'

/**
 * @typedef {Object} DatePickerProps
 *
 * @property {string | React.ReactNode} [prefixo]
 * @property {'default' | 'multiple' | 'range'} [type]
 * @property {string} [placeholder]
 * @property {string | React.ReactNode} [label]
 * @property {(value: Date | null) => void} onChange
 * @property {Date | Date[] | null} [value]
 * @property {Date | Date[] | null} [defaultValue]
 * @property {Date} [minDate]
 * @property {Date} [maxDate]
 * @property {boolean} [withinPortal]
 * @property {string} [name]
 * @property {boolean | string | React.ReactNode} [error]
 * @property {number} [fontSize]
 */

const customWeekDays = ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sáb']

/**
 * @param {DatePickerProps} props
 */
export default function DatePicker({
  prefixo,
  type = 'default',
  placeholder,
  label,
  onChange,
  value = undefined,
  defaultValue = undefined,
  minDate,
  maxDate,
  withinPortal = true,
  name,
  error,
  fontSize = 20
}) {
  const [opened, setOpened] = useState(false)

  const auxValue = minDate && dayjs(value).isBefore(minDate) ? minDate : value

  const weekdayFormat = (date) => {
    const dayOfWeek = date.getDay()
    return customWeekDays[dayOfWeek]
  }

  const handleIconClick = () => setOpened(true)

  const handleChange = (newValue) => {
    onChange(newValue)
    if (type === 'default') setOpened(false)
  }

  return (
    <>
      <GlobalStyles type={type} />
      <S.DatePickerInput
        fontSize={`${fontSize}px`}
        name={name}
        error={error}
        $hasPrefixo={!!prefixo}
        minDate={minDate}
        maxDate={maxDate}
        type={type}
        allowSingleDateInRange
        popoverProps={{
          withinPortal: withinPortal,
          zIndex: 99999,
          opened,
          onClose: () => setOpened(false)
        }}
        onClick={() => setOpened(true)}
        icon={<S.Prefixo>{prefixo}</S.Prefixo>}
        firstDayOfWeek={0}
        valueFormat="DD/MM/YYYY"
        zIndex={99999}
        locale="pt-BR"
        rightSection={
          <S.Img
            onClick={handleIconClick}
            src={calendarioVerde}
            alt="calendario"
          />
        }
        placeholder={placeholder}
        label={label}
        radius="xl"
        value={auxValue}
        defaultValue={defaultValue}
        onChange={handleChange}
        weekdayFormat={weekdayFormat}
      />
    </>
  )
}
